import * as LearningModuleActions from "src/app/store/learning-module/actions";
import * as FromLearningModule from "src/app/store/learning-module/selectors";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { AppRoutes } from "src/app/constants";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { LearningModuleDto } from "@api";
import { PopoverButton, PopoverComponent } from "src/app/components/popover/popover.component";
import { NavController, PopoverController } from "@ionic/angular";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-admin-modules",
  templateUrl: "./admin-modules.page.html",
  styleUrls: ["./admin-modules.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminModulesPage {
  public readonly routes: typeof AppRoutes = AppRoutes;
  public form: FormGroup;
  public readonly breadcrumbs = [
    { name: "Dashboard", link: `/${this.routes.home}` },
    { name: this.i18n.instant("ADMIN_LEARNING_MODULES.BREADCRUMB_NAME"), link: `/${AppRoutes.adminModules}` },
  ];
  public readonly loading$: Observable<boolean> = this.store.select(FromLearningModule.selectLoading);
  public readonly learningModules$: Observable<LearningModuleDto[]> = this.store.select(FromLearningModule.selectLearningModules);

  constructor(
    private readonly store: Store<RootState>,
    private readonly i18n: TranslateService,
    private readonly navController: NavController,
    private readonly popoverController: PopoverController,
  ) {
    this.form = new FormGroup({ search: new FormControl() });
  }

  public trackBy(_: number, content: LearningModuleDto): string {
    return content.id;
  }

  public async presentPopover(event: Event): Promise<void> {
    const buttons: PopoverButton[] = [
      {
        text: this.i18n.instant("ADMIN_LEARNING_MODULES.CREATE"),
        handler: (): Promise<boolean> => this.navController.navigateForward([AppRoutes.adminModules, AppRoutes.add]),
      },
    ];
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: { buttons },
      event,
    });

    await popover.present();
  }

  protected ionViewDidEnter(): void {
    this.store.dispatch(LearningModuleActions.getLearningModules());
  }
}
